// extracted by mini-css-extract-plugin
export var addButton = "_x-g";
export var cartCardSlider = "_x-c";
export var cartContainer = "_x-17";
export var cartPreview = "_x-16";
export var cartTotal = "_x-1c";
export var chartContainer = "_x-1u";
export var chartLoading = "_x-1v";
export var checkoutButton = "_x-1i";
export var checkoutButtonContainer = "_x-1b";
export var checkoutContainer = "_x-1k";
export var checkoutPreview = "_x-1j";
export var coveragePreview = "_x-z";
export var dark = "_x-15";
export var editorStyleIcon = "_x-w";
export var errorText = "_x-1s";
export var fakeCheckoutCheckbox = "_x-1q";
export var fakeCheckoutContainer = "_x-1m";
export var fakeCheckoutImage = "_x-1n";
export var fakeCheckoutTextContainer = "_x-1o";
export var fakeCheckoutTitle = "_x-1p";
export var fakeProduct = "_x-1d";
export var fakeProductImage = "_x-1f";
export var fakeProductInfo = "_x-1g";
export var fakeProductPrice = "_x-1h";
export var fakeRedoToggle = "_x-1e";
export var fullCartContainer = "_x-19";
export var fullCartHeader = "_x-18";
export var fullWidth = "_x-0";
export var generalSettingsToggle = "_x-f";
export var hoverable = "_x-x";
export var icon = "_x-1";
export var iconButtonContainer = "_x-1t";
export var light = "_x-13";
export var medium = "_x-14";
export var modalDescription = "_x-l";
export var modalLeftButton = "_x-k";
export var navigateIcon = "_x-y";
export var newSplitModal = "_x-j";
export var payNowButton = "_x-1l";
export var previewLink = "_x-2";
export var previewStyleSelector = "_x-10";
export var previewStyleSelectorSizer = "_x-11";
export var pricingSettingBlock = "_x-1r";
export var quarterCartContainer = "_x-1a";
export var richTextEditor = "_x-u";
export var richTextLabel = "_x-v";
export var selected = "_x-t";
export var selectedSplitType = "_x-p";
export var sidebarContent = "_x-9";
export var sidebarContentSection = "_x-a";
export var sidebarPaddedRow = "_x-d";
export var sidebarSectionHeader = "_x-7";
export var sidebarSectionTitle = "_x-8";
export var sidebarSettingRow = "_x-b";
export var sidebarStyleSelector = "_x-e";
export var skeletonBlock = "_x-12";
export var splitContent = "_x-q";
export var splitContentContainer = "_x-5";
export var splitFooterContainer = "_x-r";
export var splitFormActions = "_x-i";
export var splitHeaderContainer = "_x-h";
export var splitName = "_x-3";
export var splitPage = "_x-4";
export var splitSidebarContainer = "_x-6";
export var splitTypeContainer = "_x-m";
export var splitTypeDescription = "_x-o";
export var splitTypeSelection = "_x-n";
export var treatmentNameButton = "_x-s";